<head-meta [title]="this.title" />
<app-help-button src="/assets/help/providers/detail.md" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <ng-container *ngrxLet="provider$ as provider; error as e; complete as c">
                @if(provider) {
                    <div class="navbar bg-base-100">
                        <div class="flex-none">
                          <a routerLink="/providers" routerLinkActive="active" class="btn btn-square btn-ghost text-primary"><fa-icon [icon]="faArrowLeft" class="w-5"></fa-icon></a>
                        </div>
                        <div class="flex-1">
                          <h1 class="h1 ml-4">{{provider.name}}</h1>
                        </div>
                        <div class="flex-none">
                            @if(this.auth.has('provider_update')) {
                                <button [routerLink]="'/providers/' + this.id + '/edit'" routerLinkActive="active" class="btn btn-ghost text-primary">
                                    <fa-icon [icon]="faPenToSquare" class="w-5"></fa-icon> Edit
                                </button>
                            }
                        </div>
                    </div>
                    <hr class="hr" />
                    <div class="overflow-hidden bg-white shadow sm:rounded-lg">
                        <div class="border-t border-gray-100">
                            <dl class="divide-y divide-gray-100">
                                <div>
                                    <app-detail-display title="Devices" [value]="provider.devices.length.toString()" />
                                </div>
                                <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt class="text-sm font-medium text-gray-900">Status</dt>
                                    <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                        @if(provider.active) {
                                            <fa-icon [icon]="faCheck" class="w-5 text-primary"></fa-icon> Active
                                        } @else {
                                            <fa-icon [icon]="faXmark" class="w-5 text-error"></fa-icon> Not Active
                                        }
                                    </dd>
                                </div>
                                @if(this.auth.has('provider_update')) {
                                    <div>
                                        <app-created-updated-display [entity]="provider" />
                                    </div>
                                }
                            </dl>
                        </div>
                    </div>
                }
                <app-loading-error-block [error]="e?.error" [complete]="c" />
            </ng-container>
        </div>
    </div>
</article>